import * as PIXI from 'pixi.js';

/**
 * Base class that provides EventEmitter functionality for Luminary classes.
 * This replaces PIXI.Container as the base class for Container, allowing
 * Container to hold an internal PIXI.Container instance instead of extending it.
 */
export class LuminaryBase extends PIXI.utils.EventEmitter {
    _name: string = '';

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }
}
